import { CompanyResponseInterface } from "@crm/interface";
import { MiniUsersResponseInterface } from "../users/users-response.interface";

export interface ClientsResponseInterface {
  id: string;
  contact_person: string | null;
  designation: string | null;
  contact_number: string | null;
  email: string | null;
  status: ClientStatus;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  company: CompanyResponseInterface;
}

export enum ClientStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  DELETED = 'deleted'
}